// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class SagaObject_abstract extends PersistentObject {
  static $t: string = 'SagaBase.SagaObject';
  $t: string = 'SagaBase.SagaObject';

  public static GetMembers(): string[] {
    return [
      'SecurityClearance',
      'ObjGuid',
      'Owner',
      'CreatedUTC',
      'EffectiveDateUtc',
      'ModifiedUTC',
      'Deleted',
      'UserID',
      'UserName',
      'OwnerName',
      'TopMostUid'
    ].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return SagaObject_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.CreatedUTC = this.CreatedUTC && new Date(this.CreatedUTC);
    this.EffectiveDateUtc = this.EffectiveDateUtc && new Date(this.EffectiveDateUtc);
    this.ModifiedUTC = this.ModifiedUTC && new Date(this.ModifiedUTC);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SecurityClearance: SagaBase.SecurityClearances = SagaBase.SecurityClearances.None;
  public ObjGuid: Guid = GuidTools.Empty;
  public Owner: number = 0;
  public CreatedUTC: Date = new Date();
  public EffectiveDateUtc: Date = new Date();
  public ModifiedUTC: Date = new Date();
  public Deleted: boolean = false;
  public UserID: number;
  public UserName: string = ' - ';
  public OwnerName: string = '';
  public TopMostUid: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.ObjGuid;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
